export const initialState = {
  pods: {
    filterValue: "1 hours",
  },
};

export function PODS_CHART_PERIOD_CHANGE(nextState, { filterValue }) {
  nextState.pods.filterValue = filterValue;
}
